/**
 * RTK Query endpoints — Items
 *
 * Migrated from: src/pages/items/actions.js
 *
 * Pass the same `{ range, filters, sort }` params shape the legacy
 * `getItems(params)` used so cache keys stay stable.
 *
 * `deleteItems` accepts an array of ids in the body and hits
 * `DELETE /su/items/delete` (matches the legacy contract).
 *
 * Image uploads use the shared `useUploadFileMutation` from uploadApi.js.
 */

import { baseApi } from './baseApi';
import { buildQueryString } from './utils';

const itemApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    itemList: builder.query({
      query: (params = {}) => ({
        url: `/su/items${buildQueryString(params)}`,
        method: 'GET',
      }),
      providesTags: (result) =>
        result?.items
          ? [
              ...result.items.map(({ id }) => ({ type: 'Item', id })),
              { type: 'Item', id: 'LIST' },
            ]
          : [{ type: 'Item', id: 'LIST' }],
    }),

    createItem: builder.mutation({
      query: (data) => ({
        url: '/su/items',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [{ type: 'Item', id: 'LIST' }],
    }),

    editItem: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/su/items/${id}/edit`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: 'Item', id },
        { type: 'Item', id: 'LIST' },
      ],
    }),

    deleteItems: builder.mutation({
      query: (data) => ({
        url: '/su/items/delete',
        method: 'DELETE',
        body: data,
      }),
      invalidatesTags: [{ type: 'Item', id: 'LIST' }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useItemListQuery,
  useCreateItemMutation,
  useEditItemMutation,
  useDeleteItemsMutation,
} = itemApi;

export default itemApi;
